import { FunctionComponent } from 'react';
import { Box, Dialog } from '@primer/react';
import { CJRButton } from '../../basicComponents/cjrButton/cjrButton';

export const QrCodeDialogSingle: FunctionComponent<any> = ({
  setConfirm,
  confirm,
  roomName,
  link,
}) => {
  return (
    <Dialog
      aria-labelledby="label"
      isOpen={confirm}
      onDismiss={() => setConfirm(false)}
      sx={{ height: 'initial !important' }}
    >
      <div
        style={{
          height: '80px',
          boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.25)',
          padding: '28px',
          display: 'flex',
          justifyContent: 'center',
          color: '#3B147A',
          textAlign: 'center',
          fontSize: '22px',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: 'normal',
        }}
      >
        QR Code for {roomName}
      </div>
      <Box p={4}>
        {link ? (
          <Box display="flex" height="200px" justifyContent="center">
            <img
              src={`https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(
                link
              )}&size=200x200`}
              style={{ boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.25)' }}
            />
          </Box>
        ) : (
          <Box alignItems="center" display="flex" height="200px" justifyContent="center" />
        )}
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        p={4}
        style={{ boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.25)' }}
      >
        <CJRButton
          onClick={() => setConfirm(false)}
          style={{ maxWidth: '200px' }}
          variant="juicyPrimary"
        >
          Close
        </CJRButton>
      </Box>
    </Dialog>
  );
};
